import {faBars} from "@fortawesome/pro-solid-svg-icons/faBars";
import {faCaretRight} from "@fortawesome/pro-solid-svg-icons/faCaretRight";
import {faXmark} from "@fortawesome/pro-solid-svg-icons/faXmark";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSystemChecks} from "@twigsby/client-data";
import {
    ColourSolid,
    FlexGap,
    StackVertical, useLayout, useOutsiderDetector
} from "@twigsby/frontend-framework";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {AccountHeader} from "../../Components/Account/AccountHeader";
import {UserAccountAllowance} from "../../Components/User/UserAccountAllowance";
import {useSite} from "../../Providers/SiteInterfaceProvider";
import {AccountRoutes} from "../../Routes/Account/AccountRoutes";
import {PaymentRoutes} from "../../Routes/Account/PaymentRoutes";
import {ReferralRoutes} from "../../Routes/Account/ReferralRoutes";
import {SecurityRoutes} from "../../Routes/Account/SecurityRoutes";
import {SiteSettingsRoutes} from "../../Routes/Account/SiteSettingsRoutes";
import {YourPlanRoutes} from "../../Routes/Account/YourPlanRoutes";

const SettingsEntry = (props: any) => {
    return (
        <div onClick={props.callback} className="list-item-wrapper">
            <div className="list-item">
                <div className={`list-item-media-container list-item-featured ${props.iconBg}`}>
                    <FontAwesomeIcon icon={props.icon} fixedWidth={true} />
                </div>
                <div className="list-item-container"><span className="list-item-title">{props.title}</span></div>
                <div className="list-item-addon">
                    <FontAwesomeIcon icon={faCaretRight} fixedWidth={true} />
                </div>
            </div>
        </div>
    )
}

const AccountOverview = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const{ t } = useTranslation();
    const { isLarge } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();

    const [ listOpen , setListOpen] = useState<boolean>(false);
    const [ currentPage, setCurrentPage ] = useState<string>(location.pathname.replace('/manage-account', ''));

    const containerRef = useRef<any>();
    const listRef = useRef<HTMLDivElement>(null);

    useOutsiderDetector(listRef, () => setListOpen(false) );

    const HandleNavigation = (path: string) => {
        navigate(path);
        setListOpen(false);
    }

    useEffect(() => {
        updatePageMeta({
            title: t('actions.manageAccount')
        });
        setCurrentPage(location.pathname.replace('/manage-account', ''));
    }, [currentLocale, location]);

    return (
            <div className='content-main content-area-narrow ' ref={containerRef}>

                <div className={`container-narrow pb-sm ${isLarge || currentPage === '' ? 'pt-sm' : ''}`}>

                    <StackVertical gap={FlexGap.ExtraLarge}>
                        {(isLarge || currentPage === '') && (
                            <AccountHeader inOverview={true} />
                        )}

                        <div className={`account-overview-container ${currentPage ? 'active' : ''}`}>
                            <div className={`account-overview-navigation sticky ${listOpen? 'open' : ''} `} ref={listRef}>

                                {!isLarge && currentPage && (
                                    <div className={'account-info-trigger'} onClick={() => setListOpen(!listOpen)}>
                                        <FontAwesomeIcon icon={listOpen ? faXmark : faBars} style={{ marginInlineEnd: '.75em' }} fixedWidth />
                                        <h6 className={'m-0 sub-heading'}>{t('actions.manageAccount')}</h6>
                                    </div>
                                )}

                                <div className={'account-info-list'}>
                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${YourPlanRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {YourPlanRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routePlan${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${AccountRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {AccountRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routeAccount${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    path={item.path}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${PaymentRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {PaymentRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routePayment${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    path={item.path}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${SecurityRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {SecurityRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routeSecure${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    path={item.path}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${ReferralRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {ReferralRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routeReferral${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    path={item.path}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                    <StackVertical extraClass={'account-info-group'}>
                                        <div className={'account-info-meta'}>
                                            <div className={`account-info-section-title`}>{t(`settings.groupHeadings.${SiteSettingsRoutes[0].group}`)}</div>
                                        </div>
                                        <div className={'list-group'}>
                                            {SiteSettingsRoutes.map((item) =>
                                                <SettingsEntry
                                                    key={`routeSite${item.title}`}
                                                    title={t(`settings.sections.${item.title}`)}
                                                    path={item.path}
                                                    icon={item.icon}
                                                    iconBg={item.colour || ColourSolid.Warning}
                                                    callback={() => HandleNavigation(item.path)}
                                                />
                                            )}
                                        </div>
                                    </StackVertical>

                                </div>
                            </div>
                            <div className={`account-overview-content`}>
                                <Outlet />
                            </div>
                        </div>

                        <div className={'faded text-center'}>
                            {process.env.REACT_APP_NAME} - {process.env.REACT_APP_VERSION}
                        </div>

                    </StackVertical>
                </div>

            </div>
    )
}

export default AccountOverview
